if (!customElements.get('dropdown-input')) {
  const DropdownDisclosureElement = customElements.get('dropdown-disclosure');

  if (DropdownDisclosureElement) {
    class DropdownInput extends DropdownDisclosureElement {
      constructor() {
        super();
      }

      init() {
        this.select = this.querySelector('select');
        this.label = this.querySelector('[data-label]');
        this.buttons = this.querySelectorAll(
          'button:not([data-dropdown-close])',
        );
        this.checkboxes = Array.from(
          this.querySelectorAll('input[type="checkbox"]'),
        );
        if (this.buttons.length > 0) {
          this.setButtonsHandlers();
          this.hideSelect();
          this.setSelectedOption();
        } else if (this.checkboxes.length > 0) {
          this.addEventListener('change', (e) => {
            const checkedCheckboxes = this.getCheckedCheckboxes(e);
            const text = this.hasAttribute('data-allow-one')
              ? e.target.dataset.label
              : checkedCheckboxes.length;

            this.label.textContent = text;
            this.label.classList.toggle(
              'visually-hidden',
              checkedCheckboxes.length === 0,
            );
          });
        }
        super.init();
      }

      setButtonsHandlers() {
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', (event) =>
            this.onOptionSelect(event, index),
          );
        });
      }

      hideSelect() {
        if (!this.select) return;

        this.select.classList.add('hidden');
      }

      onOptionSelect(event, index) {
        event.preventDefault();
        this.select
          .querySelector('option[selected]')
          .removeAttribute('selected');
        this.select.options[index].setAttribute('selected', 'selected');
        this.select.value = event.target.dataset.value;
        if (this.label)
          this.label.textContent = this.select.options[index].text;
        this.setSelectedOption(event.target, index);
      }

      setSelectedOption(buttonOption) {
        const buttonEl =
          buttonOption || this.buttons[this.select.selectedIndex];
        this.buttons.forEach((button) => {
          button.parentElement.classList.remove('is-active');
        });
        buttonEl.parentElement.classList.add('is-active');
        this.select.dispatchEvent(new Event('change'));
        if (buttonOption) {
          this.select.closest('form').dispatchEvent(new Event('input'));
        }
        this.setButtonsHandlers();
      }

      getCheckedCheckboxes(e) {
        return this.checkboxes.filter((checkbox) => {
          if (this.hasAttribute('data-allow-one') && e.target !== checkbox)
            checkbox.checked = false;

          return checkbox.checked;
        });
      }
    }

    customElements.define('dropdown-input', DropdownInput);
  }
}
